// Module
var code = "<template class=\"mooring-components-tab\">\n  <require from=\"./bridles-container\"></require>\n  <bridles-container if.bind=\"data.productionOrderId > 0\" production-order-id.bind=\"data.productionOrderId\"></bridles-container>\n</template>\n";
// Exports
export default code;